"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
var Types_1 = require("./Types");
var initialState = {};
function layoutHeaderReducer(state, action) {
    if (state === void 0) { state = initialState; }
    switch (action.type) {
        case Types_1.CHANGE_BREADCRUMB:
            return __assign(__assign({}, state), action.payload);
        default:
            return state;
    }
}
exports.layoutHeaderReducer = layoutHeaderReducer;
//# sourceMappingURL=Reducer.js.map